import React, { useEffect, useMemo, useState } from 'react';

import Slider from '../slider/Slider';

import Icons from '@/icons';
import { iconConstants } from '@/constants';
import { uploadMusicTypes } from '@/types';
import { generalHelpers } from '@/helpers';

import styles from './audioBox.module.scss';

interface Props {
  formvalues: uploadMusicTypes.UploadMusic;
}

const AudioBox = (props: Props) => {
  const { formvalues } = props;

  const [sliderValue, setSliderValue] = useState(0);

  const audioRef = React.useRef<HTMLAudioElement>(null);
  const sliderRef = React.useRef<HTMLInputElement>(null);

  // const duration = audioRef.current?.duration || 0;
  // const currentTime = audioRef.current?.currentTime || 0;

  const handlePlaySong = () => {
    if (audioRef.current?.paused) {
      audioRef.current?.play();
    } else {
      audioRef.current?.pause();
    }
  };

  const handleVolume = () => {
    audioRef.current!.muted = !audioRef.current!.muted;
  };

  const handleSliderChange = (e: number) => {
    setSliderValue(e);
  };

  const sliderChange = (sliderValue: number) => {
    const duration = audioRef.current?.duration || 0;

    const currentTime = (sliderValue / 100) * duration;

    audioRef.current!.currentTime = currentTime;
  };

  const renderAudioCmp = useMemo(
    () => (
      <audio
        controls
        style={{ display: 'none' }}
        ref={audioRef}
        src={formvalues.media ? URL.createObjectURL(formvalues.media) : ''}
      />
    ),
    [formvalues.media],
  );

  useEffect(() => {
    audioRef.current?.addEventListener('timeupdate', () => {
      const currentTime = audioRef.current?.currentTime || 0;
      const duration = audioRef.current?.duration || 0;

      const percentage = (currentTime / duration) * 100;
      handleSliderChange(percentage);
    });

    // audioRef.current?.addEventListener('ended', () => {
    //   audioRef.current?.pause();
    // });
  }, []);

  return (
    <div>
      <div className={styles.audio}>
        <div className={styles.audioName}>
          <p className={styles.text}>{formvalues.media?.name || ''}</p>
        </div>
        <Slider ref={sliderRef} value={sliderValue} onChange={sliderChange} />

        <div className={styles.audioInfo}>
          <div onClick={handlePlaySong}>
            {audioRef.current?.paused ? (
              <Icons type={iconConstants.ICONS.PLAY} />
            ) : (
              <Icons type={iconConstants.ICONS.PAUSE_ICON} />
            )}
          </div>

          <div onClick={handleVolume}>
            {
              <Icons
                type={
                  audioRef.current?.muted
                    ? iconConstants.ICONS.NO_VOLUME
                    : iconConstants.ICONS.VOLUME
                }
              />
            }
          </div>

          <p className={styles.audioTime}>
            {audioRef.current?.currentTime
              ? generalHelpers.convertTimeInToMinutesandSeconds(audioRef.current?.currentTime)
              : '0:00'}
            /
            {audioRef.current?.duration
              ? generalHelpers.convertTimeInToMinutesandSeconds(audioRef.current?.duration)
              : '0:00'}
          </p>
        </div>
      </div>
      {renderAudioCmp}
    </div>
  );
};

export default AudioBox;
